module.exports = __webpack_public_path__ + "img/logo-blanco.a75813e3.png";